import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import { SelectField } from '..';
import messages from '../../../text/messages';
import options from '../../../text/selectOptions';

import './../fields.css';

class BirthdayField extends React.Component {
    render() {
        const {
            input,
            placeholder,
            intl,
            hideErrors,
            meta: { touched, error, warning },
            disabled
        } = this.props;

        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);
        return (
            <div>
                <div className={`birthday-field ${disabled ? 'birthday-disabled-field' : ''}`}>
                    <div className="field-placeholder">{placeholderContent}</div>
                    <div className="row">
                        <div className="col-xs-4 month-column">
                            <Field
                                name={`${input.name}.month`}
                                component={SelectField}
                                options={options.monthsNames}
                                placeholder={messages.month}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-xs-4 day-column">
                            <Field name={`${input.name}.day`} component={SelectField} options={options.days} placeholder={messages.day} disabled={disabled} />
                        </div>
                        <div className="col-xs-4 year-column">
                            <Field
                                name={`${input.name}.year`}
                                component={SelectField}
                                options={options.years}
                                placeholder={messages.year}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                </div>
                {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
            </div>
        );
    }
}

BirthdayField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {}
};

BirthdayField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(BirthdayField);



// WEBPACK FOOTER //
// ./src/components/fields/birthday/index.jsx